import { memo, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { clsx } from 'clsx';
import { TextBlock } from '@library';
import type { Product } from '../../types';
import useLoginState from '../../../core/hooks/useLoginState';
import PreorderModeContext from '../../../preorder/PreorderModeContext';
import styles from './ProductTile.module.scss';

const ProductTileTag = ({
    product,
}: {
    product: Pick<Product, 'isNew' | 'onSale'>;
}) => {
    const isLoggedIn = useLoginState();
    const { isInPreorderMode } = useContext(PreorderModeContext);
    if (product.onSale && isLoggedIn && !isInPreorderMode) {
        return (
            <TextBlock caption center uppercase>
                <span
                    className={clsx(styles.tileTag, styles.discountTag)}
                    data-test-class="saleTag"
                >
                    SALE
                </span>
            </TextBlock>
        );
    }

    if (product.isNew) {
        return (
            <TextBlock caption center uppercase>
                <span className={clsx(styles.tileTag, styles.newTag)}>
                    <FormattedMessage id="new" />
                </span>
            </TextBlock>
        );
    }

    return <span className={styles.newIndicatorPlaceholder} />;
};

export default memo(ProductTileTag);
